// extracted by mini-css-extract-plugin
module.exports = {"confirmStyle":"bGDvosM-it6FboW9n6SsB"};